import { usePosition } from "src/api/hooks/usePosition";
import { useFeatures } from "./Features/MapFeatures";
import { useMemo } from "react";
import { useMapFiles } from "./Features/GeoJSONFiles";

function getDistanceInMeters(point1: [number, number], point2: [number, number]) {
    // Accept coordinates in [longitude, latitude] format (GeoJSON standard)
    const [lon1, lat1] = point1;
    const [lon2, lat2] = point2;
    
    const R = 6371000; // Earth's radius in meters
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + 
              Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * 
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

export function useClosestPoints() {
    const features = useFeatures();
    const {data: mapFiles} = useMapFiles();
    const userLocation = usePosition();
    const meters = useMemo(() => {
        return (userLocation.accuracy) + 5
    },[userLocation.accuracy])
    const pointsWithinMeters = useMemo(() => {
        if (!userLocation.longitude || !userLocation.latitude || !features.points) {
            return [];
        }
        const mapPoints = mapFiles?.flatMap((file) => (file as any).data.features.filter((f: any) => f.geometry.type === "Point")) ?? [];
        const filteredFeatures = [...features.points, ...mapPoints].map(feature => {
            const distance = getDistanceInMeters(
                [Number(userLocation.longitude), Number(userLocation.latitude)],
                //[12.723846926769362, 56.03742877707069],
                feature.geometry.coordinates
            );
            feature.properties.distance = distance;
            return feature;
        }).filter((feature) => {
            return feature.properties.distance < meters;
        });
        return filteredFeatures.sort((a, b) => a.properties.distance - b.properties.distance);
    }, [features.points, userLocation.longitude, userLocation.latitude, meters]);
    
    return pointsWithinMeters || [];
}